//@flow

import React, { Component } from 'react';
import { Button, ModalBody, ModalHeader } from 'reactstrap';
import isEmpty from 'lodash/isEmpty';

import Reviews from './Reviews';
import HGModal from '../HGModal';
import ReviewsForm from './ReviewsForm';
import ToolTipRatings from './ToolTipRatings';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';

/**
 * add context, not put the reviews and ratings state into redux
 * use formik as a form to submit the reply
 * username, email and reviews into formik
 * take username and email from the profile api.
 * if not, ask username and email for verification.
 * make hooks like useReviews and useRatings.
 */

type Props = {
  userImageURI: string | null,
  addReply: () => void,
  addReview: () => void,
  deleteReply: () => void,
  fetchReviews: () => void,
  deleteReview: () => void,
  resetReviews: () => void,
  openLoginModal: () => void,
  hasBeenUpdated: () => void,
  sendRatings: () => void,
  fetchRatings: () => void,
  resetRatings: () => void,
  onUpdated: boolean,
  isLoggedIn: boolean,
  ratingsTitles: Array<String>,
  numberOfReviews: number,
  allowReview: boolean,
  isMobile: Boolean,
};

type State = { modal: boolean };

// const styles = { h2: { lineHeight: '30px' } };

export default class ReviewBox extends Component<Props, State> {
  static defaultProps = {
    allowReview: true,
  };

  componentDidMount() {
    const { fetchReviews, fetchRatings } = this.props;

    fetchReviews();
    fetchRatings();
  }

  componentWillUnmount() {
    const { resetReviews, resetRatings } = this.props;

    resetReviews();
    resetRatings();
  }

  componentDidUpdate(prevProps: Props) {
    const { onUpdated, hasBeenUpdated } = this.props;

    const isSubmittedReviews = !prevProps.onUpdated && prevProps.onUpdated !== onUpdated;

    if (isSubmittedReviews) {
      const isReviewModalOpen = this.reviewModal && Boolean(this.reviewModal.state.modal);
      const closeModal = this.toggleModal;

      if (isReviewModalOpen) closeModal();
      hasBeenUpdated();
    }
  }

  toggleModal = () => this.reviewModal.toggle();

  renderWhenNoReviews = () => {
    const { reviews, allowReview } = this.props;

    if (reviews && isEmpty(reviews)) {
      return allowReview ? (
        <div className="text-center">
          <Button onClick={this.toggleModal}>Be the first person to review</Button>
        </div>
      ) : (
        <div className="no-review-msg"> No Reviews Yet </div>
      );
    }
  };

  render() {
    const {
      addReview,
      reviews,
      openLoginModal,
      addReply,
      deleteReview,
      deleteReply,
      ratingsTitles,
      onUpdated,
      sendRatings,
      ratings,
      userImageURI,
      isLoggedIn,
      allowReview,
      isMobile
    } = this.props;

    return (
      <div className={isMobile ? 'd-block d-lg-none px-0':'d-none d-lg-block'}>
        <ErrorBoundary>
          <div className="white-panel review-container" id={isMobile ? "full-reviews-mobile" : "full-reviews"}>
             <h2 style={{ lineHeight: '30px' }}>
              Reviews {ratings && <ToolTipRatings ratings={ratings} />}
              {allowReview && (
                <span className="float-right">
                  <Button color="yellow" size="sm" onClick={this.toggleModal}>
                    <i className="icon icon-hg-pencil-notes-paper" />
                    Write a review
                  </Button>
                </span>
              )}
            </h2>

            {allowReview && (
              <HGModal
                ref={HGModal => {
                  this.reviewModal = HGModal;
                }}
                className="review-modal"
              >
                <ModalHeader toggle={this.toggleModal}>Write your review</ModalHeader>
                <ModalBody>
                  <ReviewsForm
                    ratingsTitles={ratingsTitles}
                    addReview={addReview}
                    openLoginModal={openLoginModal}
                    sendRatings={sendRatings}
                    isLoggedIn={isLoggedIn}
                    isSubmitted={onUpdated}
                  />
                </ModalBody>
              </HGModal>
            )}
            <ul className="list-comments">
                {reviews &&
                  reviews.length > 0 &&
                  reviews.map(review => {
                    const reviewHasAuthor = Boolean(review.author);
                    if (reviewHasAuthor)
                    return (
                      <Reviews
                        key={review.id}
                        review={review}
                        addReply={addReply}
                        deleteReview={deleteReview}
                        deleteReply={deleteReply}
                        openLoginModal={openLoginModal}
                        isSubmitted={onUpdated}
                        userImageURI={userImageURI}
                        isLoggedIn={isLoggedIn}
                      />
                    );
                    return null;
                  })}
            </ul>
            {this.renderWhenNoReviews()}
          </div>
        </ErrorBoundary>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ReviewsRatings/ReviewsBox.jsx